import { DashboardService } from '../../../../../service/events/dashboard.service';
import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormCommonApiService } from '../../../../../service/api/formcommon-api.service';
import { BaseForm } from '../../../../base-form';
import { FincasApiService } from '../../../../../service/api/fincas-api.service';
import { build, pool } from '../../../../../common/classes/request-builder';
import { StorageManager } from '../../../../../common/storage-manager.class';
import { environment } from '../../../../../../environments/environment';
import { MapaParcelasApiService } from '../../../../../service/api/mapa-parcelas-api.service';
import { VisitasVariedadMesApiService } from '../../../../../service/api/visitas_variedad_mes-api.service';
import { DialogSigPacComponent, ReferenciaCatastral } from './dialog/dialog.sigpac.component';
import { VentasApiService } from '../../../../../service/api/ventas-api.service';
import { SiexApiService } from '../../../../../service/api/siex-api.service';
import { UsuariosApiService } from '../../../../../service/api/usuarios-api.service';
import { ParcelasFormDefinition } from './form-definition';


import { ParcelasModel } from 'src/app/models/form-common/parcelas.model';
import { FullMapModel } from 'src/app/models/form-common/full-map.model';
import { MantenimientoModel } from 'src/app/models/trabajadores/mantenimiento.model';
import { ParcelasEnvironmentDefinition } from '../environment-variables';
import { ReactiveFormBuilderComponent } from 'src/app/common/components/reactive-form-builder/form-builder.component';
import { HttpClient } from '@angular/common/http';
import { EventPhase, FormPhase } from 'src/app/common/components/reactive-form-builder/form-request';
import { Subject } from 'rxjs';
import { TypeAheadInterface } from 'src/app/common/components/form-builder/form-builder.component';
import { VisitasVariedadMesModel } from 'src/app/models/visitas_variedad_mes/visitas_variedad_mes.model';
import { TrabajadoresApiService } from 'src/app/service/api/trabajadores-api.service';


@Component({
    selector: 'app-parcelas-form',
    standalone: false,
    templateUrl: './parcelas-form.component.html',
    styleUrls: ['./parcelas-form.component.scss']
})
export class ParcelasFormComponent extends BaseForm<ParcelasModel> implements OnInit {

    @ViewChild('sigpac', { read: DialogSigPacComponent, static: true }) sigpacDialog: DialogSigPacComponent | undefined;

    @ViewChild(ReactiveFormBuilderComponent) formBuilder!: ReactiveFormBuilderComponent<ParcelasModel>;

    public dropdownsFinalized = false;
    public form!: ParcelasFormDefinition;

    public formRequest = new ReactiveFormBuilderComponent(this.http);

    public loadingData = true;

    public dropdownLoadTrigger = new Subject<void>();

    public override model: ParcelasModel = {
        activo: '1',
        turbo: '1',
        mapa: [{} as FullMapModel]
    } as ParcelasModel;

    public mapaAux = {} as FullMapModel;

    public variedadVariosCreated = false;

    public env: ParcelasEnvironmentDefinition = new ParcelasEnvironmentDefinition();



    public origin = 'parcelas-form';

    public viewNumeroMetros = false;

    public nombreTouched = false;

    constructor(
        public override route: ActivatedRoute,
        public override router: Router,
        public formApi: FormCommonApiService,
        public fincasApi: FincasApiService,
        public mapaParcelasApi: MapaParcelasApiService,
        public override dashboard: DashboardService,
        public visitasVariedadMesApi: VisitasVariedadMesApiService,
        private readonly ventasApi: VentasApiService,
        public siexApi: SiexApiService,
        public usuariosAPI: UsuariosApiService,
        public trabajadoresApi: TrabajadoresApiService,
        private readonly zone: NgZone,
        private readonly http: HttpClient

    ) {
        super(
            route,
            router,
            dashboard,
            fincasApi.parcelasPUT,
            fincasApi.parcelasPOST,
            'parcelas',
            'Editar ' + environment.features.parcelaName,
            'Crear ' + environment.features.parcelaName
        );
    }

    ngOnInit(): void {
        this.dropdownsFinalized = false;
        this.form = new ParcelasFormDefinition(
            this.getType(),
            this.getModel() as Record<string, string>,
            this.sigpacDialog as DialogSigPacComponent,
            null
        );
        this.initFormData();
        this.expandFormRequest();
        this.formRequest.executePhase(FormPhase.LOAD);
        this.softInit(this.getType());
        this.form.model = this.model;
    }


    public async afterSend(res: any): Promise<void> {
        
        if (this.form.model.mapa) {
            this.mapaAux = this.getMapColor(this.form.model.mapa[0] as FullMapModel);
        }

        const parcela = res?.[0];

        if (parcela && this.mapaAux.coordenadas) {
            // Rellena campos que vienen del backend de parcelas
            this.mapaAux.id_parcela = parcela.id;
            this.mapaAux.id_finca = parcela.id_finca;
            if (this.env.hasClients) {
                this.mapaAux.id_cliente = parcela.id_cliente ?? '';
            }
            this.mapaAux.id_cultivo = parcela.id_cultivo ?? '';
            this.mapaAux.id_sector = parcela.id_sector ?? '';
            this.mapaAux.id_usuario = StorageManager.getUser().id;

            try {
                // 1) Comprueba si ya existe un registro de mapa para esta parcela
                const existentes = await this.mapaParcelasApi.mapaParcelasGET.toPromise() as FullMapModel[] || [];
                const existente = existentes.find(m => m.id_parcela === this.mapaAux.id_parcela); // igualdad laxa por tipos

                // 2) PUT si existe, POST si no
                if (existente?.id) {
                    this.mapaAux.id = existente.id;
                    await this.mapaParcelasApi.mapaParcelasPUT.toPromise(this.mapaAux);
                } else {
                    await this.mapaParcelasApi.mapaParcelasPOST.toPromise(this.mapaAux);
                }
            } catch (e) {
                console.error('Error sincronizando mapa_parcelas', e);
                // (opcional) aquí puedes mostrar un toast/notificación
            }
        }

        if (this.variedadVariosCreated) {
            window.location.reload();
        }

        this.goBack();
    }

    getSigPac(event: object) {
        const rc = event as ReferenciaCatastral;

        this.form.model.cod_provincia = rc.provincia ?? '';
        this.form.model.municipio = rc.municipio ?? '';
        this.form.model.poligono = rc.poligono ?? '';
        this.form.model.numero = rc.parcela ?? '';
        this.formBuilder.updateForm(this.form.model, false);
    }

    public reloadComponent() {
        this.form.mapaOpened = false;
        window.location.reload();
    }


    public formChanges(formModel: any, tag: string) {
        this.form.model = formModel;

        if (tag === 'nombre') {
            this.nombreTouched = true;
        }

        if (tag === 'id_variedad' && this.env.appName === 'avafitogest') {
            const client = StorageManager.getClient();
            const name = client?.nombre + '_' + (client?.apellidos ?? '') + '_' + formModel.id_variedad.variedad;

            this.form.model.nombre = name;
        }
    }

    public getFromMapa(datos: string) {        
        this.zone.run(() => {
            const data = JSON.parse(datos);

            if (this.env.appName !== 'amoros') {
                this.form.model.cod_provincia = data.provincia;
                this.form.model.municipio = data.municipio;
                this.form.model.poligono = data.poligono;
                this.form.model.numero = data.parcela;
                this.form.model.recinto = data.recinto;
                this.form.model.sigpac = data.refpar;
                this.form.model.uso_sigpac = data.usoSigpac;

                if (data.modo === 'sigpac') {
                    this.form.model.superficie_sigpac = data.ha;
                } else if (data.modo === 'manual') {
                    this.form.model.superficie_cultivada = data.ha;
                }
            }

            if (!this.form.model.mapa) {
                this.form.model.mapa = [{} as FullMapModel];
            }

            const mapa0 = this.form.model.mapa[0];

            if (mapa0) {
                mapa0.id_finca = this.form.model.id_finca ?? '';
                mapa0.id_sector = this.form.model.id_sector ?? '';
                mapa0.id_cultivo = (this.env.activateApiSIEX
                    ? this.form.model.id_cultivo_legacy
                    : this.form.model.id_cultivo) ?? '';
                mapa0.id_usuario = StorageManager.getUser().id;
                mapa0.coordenadas = data.coord;
                mapa0.color = data.color;

                const nombreControl = this.formBuilder.model.get('nombre');

                if (nombreControl && (nombreControl.pristine || !nombreControl.value)) {
                    if (data.nombreParcela?.trim()) {
                        this.form.model.nombre = data.nombreParcela.trim();
                    } else if (data.parcela?.trim()) {
                        this.form.model.nombre = `${this.env.parcelaName} ${data.parcela.trim()}`;
                    }
                }
            }

            this.form.mapaAbierto = false;
            this.formBuilder.updateForm(this.form.model, false);
            this.formBuilder.model.get('nombre')?.markAsPristine();
        });
    }





    public getMapColor(mapa: FullMapModel) {
        const defaultColor = '#88dd66';

        const self = mapa;

        if (this.form.lists.cultivos.selected &&
            Object.keys(this.env.customMapColorsList).includes(this.form.lists.cultivos.selected.cultivo)) {
            self.color = this.env.customMapColorsList[this.form.lists.cultivos.selected.cultivo] ?? '';
        } else {
            self.color = defaultColor;
        }
        return self;
    }


    private initFormData(): Promise<boolean> {
        this.loadingData = true;

        let builds = [
            build(this.fincasApi.fincasGET, this.form.lists.fincas, ['nombre']),
            build(this.fincasApi.sectoresGET, this.form.lists.sectores, ['nombre'], true),
            build(this.siexApi.portainjertosGET, this.form.lists.patronVina, ['sinonimo']),
            build(this.siexApi.sistemasRiegoGET, this.form.lists.sistemasRiego, ['sistema_de_riego'], true),
            build(this.fincasApi.sectoresGET, this.form.lists.sectores, ['nombre'], true),
            build(this.siexApi.comunidadesRegantesGET, this.form.lists.comunidadesRegantes, 'nombre'),
            build(this.siexApi.origenesAguaRiegoGET, this.form.lists.origenesAguaRiego, 'procedencia_del_agua_de_riego'),
        ];

        if(environment.features.showParcelasPartida) {
            builds.push(build(this.ventasApi.compradoresGET, this.form.lists.comercios, 'razon_social'),);
        }

        if (this.env.appName === 'sequiador') {
            builds.push(build(this.usuariosAPI.usuariosGET, this.form.lists.aplicadores,
                (it: MantenimientoModel) => it.nombre + ' ' + (it.apellidos || ''), true));
        } else {
            builds.push(build(this.trabajadoresApi.trabajadoresGET, this.form.lists.aplicadores,
                (it: MantenimientoModel) => it.nombre + ' ' + (it.apellidos || ''), true));
        }

        if (this.env.appName === 'avafitogest') {
            builds.push(build(this.usuariosAPI.usuariosGET, this.form.lists.usuarios,
                (it: MantenimientoModel) => it.nombre + ' ' + (it.apellidos || ''), true));
        }

        if (this.env.hasPlantas || !this.env.activateApiSIEX) {
            builds.push(
                build(this.formApi.cultivosGET, this.form.lists.cultivosLegacy, ['cultivo'], false, false),
                build(this.formApi.variedadesGET, this.form.lists.variedadesLegacy, ['variedad'])
            );
        }

        if (this.env.hasCultivosPropios) {
            builds.push(
                build([this.formApi.cultivosGET, this.siexApi.cultivosGET], this.form.lists.cultivos, ['cultivo'], false, false),
                build([this.formApi.variedadesGET, this.siexApi.variedadesGET], this.form.lists.variedades, ['variedad']),
                build(this.formApi.cultivosGET, this.form.lists.cultivosLegacy, ['cultivo'], false, false),
                build(this.formApi.variedadesGET, this.form.lists.variedadesLegacy, ['variedad'])
            );
        }

        if (this.env.activateApiSIEX && !this.env.hasCultivosPropios) {
            builds.push(
                build(this.siexApi.cultivosGET, this.form.lists.cultivos, ['cultivo'], true),
                build(this.siexApi.variedadesGET, this.form.lists.variedades, ['variedad'], true)
            );
        }

        return pool(builds, () => {
            this.loadingData = false;
        }).then(() => {
            this.dropdownsFinalized = true;
            this.dropdownLoadTrigger.next();
            return true;
        });
    }

    private expandFormRequest() {
        this.formRequest.addEvent(FormPhase.SEND, EventPhase.BEFORE, (resolve) => {
            if (this.env.variedadCanBeVarios) {
                const varios = this.form.lists.variedades.filtered.find(it => it.value && it.value.variedad === 'Varios');

                if (varios) {
                    this.model.id_variedad = varios.value?.id ?? '';
                    resolve(true);
                } else {
                    const idxCultivo = this.form.formFieldsDatosParcela.fields.map(it => it.name).indexOf('id_cultivo');
                    const idxCultivoLegacy = this.form.formFieldsDatosParcela.fields.map(it => it.name).indexOf('id_cultivo_legacy');

                    const posCampoCultivo = (this.env.hasPlantas || !this.env.activateApiSIEX) ? idxCultivoLegacy : idxCultivo;
                    const campoCultivo = this.form.formFieldsDatosParcela.fields[posCampoCultivo];

                    if (campoCultivo) {
                        this.visitasVariedadMesApi.visitasVariedadMes.POST.toPromise({
                            cultivo: (campoCultivo.input.data as TypeAheadInterface<VisitasVariedadMesModel>).selected?.cultivo ?? '',
                            variedad: 'Varios'
                        } as never).then(res => {
                            this.variedadVariosCreated = true;
                            if (res?.[0]) {
                                this.form.model.id_variedad = res[0].id ?? '';
                                this.formBuilder.updateForm(this.form.model, false);
                            }
                            return;
                        }).then(() => {
                            resolve(true);
                            return;
                        }).catch(e => {
                            console.log('catch en getPosition: ' + e);
                        }
                        );

                    }
                }
            } else {
                resolve(true);
            }
        });
    }
}